import React from 'react';
import AppRoutes from 'routes';
import { BooksProvider } from 'providers/BooksProvider';
import { LessonProvider } from 'providers/LessonProvider';
import { LoginPopup } from 'components/LoginPopup/LoginPopup';

const App = () => {
	return (
		<BooksProvider>
			<LessonProvider>
				<AppRoutes />
				<LoginPopup />
			</LessonProvider>
		</BooksProvider>
	);
};
export default App;
